var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"urge-info-count"},[_c('span',[_vm._v("优惠名额仅剩")]),_c('span',{staticClass:"urge-info-number"},[_vm._v(_vm._s(_vm.remainingCount))]),_c('span',[_vm._v("人")])])}
var staticRenderFns = []

export { render, staticRenderFns }